const logo = 'https://blueberry.azureedge.net/WillMars/willmars-logo-supplied.avif'

function Footer() {
  return (
    <footer>
      <div className="wrap">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src={logo} alt="WillMars Re" />
            <p>Global reinsurance expertise. Local market intelligence.</p>
          </div>
          <div className="office">
            <h3>WillMars Reinsurance Brokers (EA) Limited</h3>
            <p>
              The Mirage Towers, Chiromo Road, Westlands District, Westlands, P.O Box 79012 Tom Mboya St, Nairobi, Kenya
              <br />
              <br />
              IRA/06R/032/2026<br />
              +254 722 529 112
            </p>
          </div>
          <div className="office">
            <h3>WillMars Reinsurance Brokers Limited</h3>
            <p>
              1st Floor, VIVA Tower, Suite No 06, Ally Hassan Mwinyi Rd, Po.Box 38346, Dar Es Salaam Tanzania
              <br />
              <br />
              BRELA License 20000108035<br />
              +255 789 88 66 35<br />
              +255 22 2150 079
            </p>
          </div>
        </div>
        <div className="legal">
          <span>© 2026 WillMars Reinsurance Brokers</span>
          <span>Professional. Independent. Connected.</span>
        </div>
      </div>
    </footer>
  )
}

export default Footer
